var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1748,
    height: 560,
    viewBox: "0 0 1748 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_6915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 140.01C77.2497 140.01 139.88 77.3154 139.88 0C139.88 77.3154 202.51 140.01 279.759 140.01C279.759 217.325 217.129 280.02 139.88 280.02C62.63 280.02 0 217.325 0 140.01Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.62 0C419.62 77.3154 482.25 140.01 559.5 140.01C482.25 140.01 419.62 202.705 419.62 280.02C342.37 280.02 279.74 217.325 279.74 140.01C279.74 62.6946 342.37 0 419.62 0Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.5 420.01C482.25 420.01 419.62 482.705 419.62 560.02C419.62 482.705 356.99 420.01 279.74 420.01C279.74 342.695 342.37 280 419.62 280C496.87 280 559.5 342.695 559.5 420.01Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.88 560C139.88 482.685 77.2497 419.99 0 419.99C77.2497 419.99 139.88 357.296 139.88 279.98C217.129 279.98 279.759 342.675 279.759 419.99C279.759 497.306 217.129 560 139.88 560Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748 142.99H1670.57V417.607H1748V478.374H1517.48V417.607H1594.91V142.99H1517.48V82.2227H1748V142.99Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.84 488.504C1126.31 488.504 1067.93 393.191 1067.93 279.999C1067.93 166.807 1126.31 71.4941 1272.84 71.4941C1419.38 71.4941 1477.76 169.191 1477.76 279.999C1477.76 390.807 1419.38 488.504 1272.84 488.504ZM1147.17 279.999C1147.17 375.312 1180.52 425.949 1272.84 425.949C1365.17 425.949 1397.92 375.312 1397.92 279.999C1397.92 184.686 1365.17 134.05 1272.84 134.05C1180.52 134.05 1147.17 184.686 1147.17 279.999Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.396 246.785L1076.23 471.957V475.533H984.502L864.168 301.593L796.274 374.876V475.553H720.037V79.3809H796.274V277.755L971.392 79.3809H1070.27L915.396 246.785Z",
    fill: "#191919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_6915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1748,
    height: 560,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.d1b658d1c12d902a3a1e38df5994e713.svg";
export { ForwardRef as ReactComponent };